const alpha = Array.from(Array(26)).map((_, i) => i + 65);
export const ALPHABET = alpha.map((x) => String.fromCharCode(x));
export const PAGINATE_ALL_LIMIT = 10000;
